export enum INSURANCE_PROVIDER_SOURCE {
  AVAILITY = 'availity',
  CHANGE_HEALTHCARE = 'change_healthcare',
}
